import {format} from 'sql-formatter'

export const DefaultOptions = {
  tabWidth: 2,
  useTabs: false
}

export default async function formatSQL(input, options={}) {
  const {tabWidth, useTabs} = {...DefaultOptions, ...options}

  return format(input, {
    tabWidth,
    useTabs,
    keywordCase: 'upper',
  })
}
